// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonStatusIncompleteCircleV1_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97594 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 7.21207 2.15519 6.43185 2.45672 5.7039C2.75825 4.97594 3.20021 4.31451 3.75736 3.75736C4.31451 3.20021 4.97595 2.75825 5.7039 2.45672C6.43185 2.15519 7.21207 2 8 2L8 8L8 14Z" fill="#0050F2"/>
  <path d="M8 2C8.78793 2 9.56815 2.1552 10.2961 2.45672C11.0241 2.75825 11.6855 3.20021 12.2426 3.75736C12.7998 4.31451 13.2417 4.97595 13.5433 5.7039C13.8448 6.43185 14 7.21207 14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2418 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14L8 8L8 2Z" fill="#D1D9E5"/>
</svg>
`;
/**
 * IconCommonStatusIncompleteCircleV1 is a generated icon component.
 */
let IconCommonStatusIncompleteCircleV1 = IconCommonStatusIncompleteCircleV1_1 = class IconCommonStatusIncompleteCircleV1 extends IconBaseElement {
    render() {
        return html `${IconCommonStatusIncompleteCircleV1_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonStatusIncompleteCircleV1.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonStatusIncompleteCircleV1 = IconCommonStatusIncompleteCircleV1_1 = __decorate([
    customElement('zui-icon-common-status-incomplete-circle-v-1')
], IconCommonStatusIncompleteCircleV1);
export { IconCommonStatusIncompleteCircleV1 };
